import React, { useState } from 'react';
import SinglePlateInput from './SinglePlateInput';
import BatchPlateInput from './BatchPlateInput';

const LicensePlateInput = () => {
  const [activeSubTab, setActiveSubTab] = useState('single');

  return (
    <div className="license-plate-input">
      <div className="sub-tabs">
        <button
          className={`sub-tab-button ${activeSubTab === 'single' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('single')}
        >
          Biển số lẻ
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'batch' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('batch')}
        >
          Biển số dãy
        </button>
      </div>

      <div className="sub-tab-content">
        {activeSubTab === 'single' && <SinglePlateInput />}
        {activeSubTab === 'batch' && <BatchPlateInput />}
      </div>
    </div>
  );
};

export default LicensePlateInput;
